module.exports = __webpack_public_path__ + "img/nycxrp.8df6ac96.png";